import * as i0 from "@angular/core";
var AppSettings = /** @class */ (function () {
    function AppSettings() {
    }
    AppSettings.MAX_UPLOAD_FILE_SIZE = 5242880;
    AppSettings.ngInjectableDef = i0.defineInjectable({ factory: function AppSettings_Factory() { return new AppSettings(); }, token: AppSettings, providedIn: "root" });
    return AppSettings;
}());
export { AppSettings };
